<template>

  <AppLayout>
    <div>
      <WelcomeLayout />
      <CarouselLayout />
      <StudioTimesLayout />
      <YogaLayout />
      <BookingLayout />
      <AboutLayout />
    </div>
    
  </AppLayout>
</template>

<script>
import AppLayout from './components/layouts/AppLayout.vue';
import WelcomeLayout from './components/layouts/WelcomeLayout.vue';
import CarouselLayout from './components/layouts/CarouselLayout.vue';
import StudioTimesLayout from './components/layouts/StudioTimesLayout.vue';
import BookingLayout from './components/layouts/BookingLayout.vue';
import AboutLayout from './components/layouts/AboutLayout.vue';
import YogaLayout from './components/layouts/YogaLayout.vue';

export default {
    name: 'App',
    components: {
      AppLayout,
      WelcomeLayout,
      CarouselLayout,
      StudioTimesLayout,
      BookingLayout,
      AboutLayout,
      YogaLayout
    }
}

</script>

<style>

  #app {
    font-family: Avenir, Helvetica, Arial, sans-serif;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    text-align: center;
    color: #2c3e50;
    margin-top: 10px;
  }

</style>
